import * as React from "react";
import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Modal, Row } from "components/bootstrap";
import FormikInput from "components/common/FormikInput";
import Spinner from "components/common/Spinner";
import { ModalSubmit, IfPermitted } from "components/common";
import { ConfigurationsActions, ConfigurationsStore } from "stores/configurations/ConfigurationsStore";
import { ConfigurationType } from "components/configurations/ConfigurationTypes";
import { getConfig } from "components/configurations/helpers";
import { useStore } from "stores/connect";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import { DEFAULT_WELCOME_PAGE_CONFIG } from "logic/welcome/welcomePageConfig";
const StyledDefList = styled.dl.attrs({ className: "deflist" })(
  ({ theme }) => css`
    &&.deflist {
      dd {
        padding-left: ${theme.spacings.md};
        margin-left: 200px;
      }
    }
  `
);
const LabelSpan = styled.span(
  ({ theme }) => css`
    margin-left: ${theme.spacings.sm};
    font-weight: bold;
  `
);
const configType = ConfigurationType.WELCOME_PAGE_CONFIG;
const WelcomePageConfig = () => {
  const { t } = useTranslation("configurations");
  const [showModal, setShowModal] = useState(false);
  const [viewConfig, setViewConfig] = useState(void 0);
  const [formConfig, setFormConfig] = useState(void 0);
  const configuration = useStore(ConfigurationsStore, (state) => state == null ? void 0 : state.configuration);
  const sendTelemetry = useSendTelemetry("welcome-page");
  useEffect(() => {
    ConfigurationsActions.list(configType).then(() => {
      var _a;
      const config = (_a = getConfig(configType, configuration)) != null ? _a : DEFAULT_WELCOME_PAGE_CONFIG;
      setViewConfig(config);
      setFormConfig({ metrics_enabled: !config.disable_metrics });
    });
  }, [configuration]);
  const saveConfig = (values) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.CONFIGURATIONS.WELCOME_PAGE_UPDATED, {
      app_action_value: "configuration-save"
    });
    ConfigurationsActions.update(configType, { disable_metrics: !values.metrics_enabled }).then(() => {
      setShowModal(false);
    });
  };
  const resetConfig = () => {
    setShowModal(false);
    setFormConfig({ metrics_enabled: !viewConfig.disable_metrics });
  };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h2", null, t("welcome_page.title")), /* @__PURE__ */ React.createElement("p", null, t("welcome_page.description")), !viewConfig ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledDefList, null, /* @__PURE__ */ React.createElement("dt", null, t("welcome_page.metrics"), ":"), /* @__PURE__ */ React.createElement("dd", null, viewConfig.disable_metrics ? t("markdown.disabled") : t("markdown.enabled"))), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "clusterconfigentry:edit" }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Button,
    {
      type: "button",
      bsSize: "xs",
      bsStyle: "info",
      onClick: () => {
        setShowModal(true);
      }
    },
    t("shared.edit_configuration")
  ))), /* @__PURE__ */ React.createElement(Modal, { show: showModal && !!formConfig, onHide: resetConfig }, /* @__PURE__ */ React.createElement(Formik, { onSubmit: saveConfig, initialValues: formConfig }, ({ isSubmitting }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, t("welcome_page.update_title"))), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { sm: 12 }, /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      type: "checkbox",
      name: "metrics_enabled",
      id: "metrics_enabled",
      label: /* @__PURE__ */ React.createElement(LabelSpan, null, t("welcome_page.enable_metrics")),
      help: t("welcome_page.enable_metrics_help")
    }
  )))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      onCancel: resetConfig,
      isSubmitting,
      isAsyncSubmit: true,
      submitLoadingText: t("shared.update_configuration"),
      submitButtonText: t("shared.update_configuration")
    }
  )))))));
};
export default WelcomePageConfig;
